module.exports = __webpack_public_path__ + "static/media/TEMENOS.f59fb861.png";